<template>
    <a-row>
        <a-col>
            <a-menu mode="horizontal">
                <a-sub-menu key="user">
                    <template #title>
                        <a-avatar shape="square" :size="40" :src="adminInfo.avatar">
                        </a-avatar>
                    </template>
                    <a-menu-item class="nav-user-dropdown">
                        <router-link :to="{name: 'AdminSettings'}">设置</router-link>
                    </a-menu-item>
                    <a-menu-item class="nav-user-dropdown">
                        <router-link :to="{name: 'Logout'}">退出</router-link>
                    </a-menu-item>
                </a-sub-menu>
            </a-menu>
        </a-col>
    </a-row>
</template>

<script>
import { GetSessionStorage, SetSessionStorage, STORE_KEY_ADMIN_INFO } from '@/utils/storage';
import { Admin } from '@/model/admin';
import { Config } from '@/config';
import { NoneImage } from '@/utils/utils';

export default {
    setup() {
        let _info = GetSessionStorage(STORE_KEY_ADMIN_INFO)
        let adminInfo = _info ? _info : {username: "", avatar: NoneImage} ;
        if (!adminInfo) {
            new Admin().initByRequest().then((res) => {
                SetSessionStorage(STORE_KEY_ADMIN_INFO, {
                    username:   res.username,
                    avatar:     Config.domainOss+res.avatar,
                });
            }).then(()=>{
                adminInfo = GetSessionStorage(STORE_KEY_ADMIN_INFO);
            });
        }

        return {
            adminInfo,
        }
    }
};
</script>

<style>
.anticon-menu-fold.trigger,
.anticon-menu-unfold.trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
}

.anticon-menu-fold.trigger:hover,
.anticon-menu-unfold.trigger:hover {
    color: #1890ff;
}

.nav-user-dropdown {
    background-color: #fff !important;
}
.nav-user-dropdown .ant-btn-link,
.nav-user-dropdown .ant-btn-link:hover,
.nav-user-dropdown .ant-btn-link:focus {
    color: black;
}
</style>